export default {
    "lang": "俄语",
    "application": {
        "name": "Система публикации информации"
    },
    "ajaxTip": {
        "success": "Успешно",
        "error": "Ошибка",
        "noAccess": "Нет прав доступа к этому ресурсу",
        "notFound": "Запрашиваемый ресурс не существует",
        "serverBusy": "Сервер загружен",
        "timeOut": "Тайм-аут"
    },
    "menu": {
        "home": "Главная",
        "template": "Управление шаблонами",
        "program": "Управление программами",
        "playplan": "План воспроизведения",
        "device": "Управление устройствами",
        "source-material": "Управление материалами",
        "material": "Материалы",
        "checkManage": "Управление проверкой",
        "setting": "Настройки",
        "usercenter": "Личный кабинет",
        "adminManage": "Управление устройствами",
        "schedule": "Плановые задачи",
        "capitalassets": "Управление активами",
        "modifyPassword": "Сменить пароль",
        "logout": "Выйти из системы",
        "add": "Добавить",
        "edit": "Редактировать",
        "delete": "Удалить",
        "view": "Просмотреть",
        "menu_1": "Главная",
        "menu_2": "Управление устройствами",
        "menu_3": "Редактировать (Расширенные настройки - Базовое редактирование - Смена сети)",
        "menu_4": "Мгновенные команды",
        "menu_5": "Редактировать (Перевод в другой отдел)",
        "menu_6": "Стратегия",
        "menu_7": "Настройки громкости",
        "menu_8": "Настройки яркости",
        "menu_9": "Настройки загрузки",
        "menu_10": "Настройки сна",
        "menu_11": "Свойства устройства",
        "menu_12": "Редактировать/Добавить",
        "menu_13": "Управление программами",
        "menu_14": "История публикаций",
        "menu_15": "Удалить (Пакетно/По отдельности)",
        "menu_16": "Программы в процессе публикации",
        "menu_17": "Группировка",
        "menu_19": "Список программ",
        "menu_20": "Редактирование контента",
        "menu_21": "Копировать программу",
        "menu_23": "Опубликовать программу",
        "menu_24": "Управление материалами",
        "menu_25": "Загрузить",
        "menu_28": "Быстрая публикация",
        "menu_29": "Управление шаблонами",
        "menu_30": "Общие шаблоны",
        "menu_31": "Использовать сейчас",
        "menu_32": "Мои шаблоны",
        "menu_33": "Опубликовать в общие шаблоны",
        "menu_35": "История обмена",
        "menu_36": "Управление аудитом",
        "menu_37": "Аудит программ",
        "menu_38": "Аудит (Утвердить/Отклонить)",
        "menu_39": "Аудит материалов",
        "menu_41": "История аудита (Оператор)",
        "menu_42": "История аудита (Аудитор)",
        "menu_43": "Просмотреть количество утверждений",
        "menu_44": "Управление организацией",
        "menu_45": "Управление журналами",
        "menu_46": "Журналы воспроизведения",
        "menu_47": "Журналы публикаций",
        "menu_48": "Журналы ошибок",
        "menu_49": "Журналы операций",
        "menu_50": "Журналы файлов",
        "menu_51": "Журналы входа в систему",
        "menu_52": "Утверждение контента",
        "menu_53": "Хранилище",
        "menu_54": "Организационная структура",
        "menu_55": "Роли и права доступа",
        "menu_56": "Авторизация",
        "menu_57": "Просмотреть (Права авторизации)",
        "menu_58": "Участники организации",
        "menu_60": "Сбросить пароли подчиненных пользователей",
        "menu_61": "Управление активами",
        "menu_62": "Мой баланс",
        "menu_63": "Просмотреть (Детали финансов)",
        "menu_64": "Мой расход трафика",
        "menu_65": "Просмотреть (Детали расхода трафика)",
        "menu_66": "Покупить трафик",
        "menu_67": "Мой объем хранения",
        "menu_68": "Мои устройства",
        "menu_69": "Детали заказа",
        "menu_70": "Просмотреть (Пополнение счета)",
        "menu_71": "Просмотреть (Приобретенные шаблоны)",
        "menu_72": "Просмотреть (Приобретенный трафик)",
        "menu_73": "Другие права доступа",
        "menu_74": "Просмотреть (Статистика материалов и программ)",
        "menu_75": "Просмотреть (Активы)",
        "menu_76": "Просмотреть (Облачный трафик/Статистика)",
        "menu_77": "Просмотреть (Статистика онлайн устройств)"
    },
    "login": {
        "terminalServiceSystem": "Интеллектуальная система обслуживания терминалов",
        "accountLogin": "Вход по аккаунту",
        "register": "Регистрация",
        "accountLoginTip": "Уже есть аккаунт? Войдите",
        "scanQRCode": "Пожалуйста, отсканируйте QR-код",
        "readAndAgree": "Я прочитал(а) и согласен(на)",
        "readAndAgreeLink": "Пользовательское соглашение",
        "readAndAgreeAgreement": "Пожалуйста, прочитайте и согласитесь с пользовательским соглашением",
        "forgetpassword": "Забыли пароль?",
        "resetpassword": "Сбросить пароль",
        "phoneEmptyTip": "Пожалуйста, введите номер телефона",
        "nextStep": "Далее",
        "title": "Добро пожаловать",
        "submit": "Войти",
        "userName": "Логин",
        "password": "Пароль",
        "userNameEmptyTip": "Пожалуйста, введите логин",
        "passwordEmptyTip": "Пожалуйста, введите пароль",
        "passwordFormatTip": "Пожалуйста, введите пароль в правильном формате",
        "passwordIsOk": "Пожалуйста, подтвердите пароль",
        "passwordSign": "Пожалуйста, введите пароль",
        "codeTip": "Пожалуйста, введите код подтверждения",
        "phone": "Номер телефона не может быть пустым",
        "code": "Код подтверждения не может быть пустым",
        "nickname": "Название компании не может быть пустым",
        "pass": "Пароль не может быть пустым",
        "pwdMessage": "Пароль должен содержать от 8 до 20 символов, без пробелов, и включать 3 из следующих типов: заглавные буквы, строчные буквы, цифры, специальные символы",
        "pwdMessage01": "Пожалуйста, введите пароль из букв и цифр, не менее 8 символов",
        "pwdMessage02": "Пароль должен содержать от 8 до 20 символов",
        "pwdMessage03": "Пароль не может содержать пробелы",
        "pwdMessage04": "Пароль должен включать 3 из следующих типов: заглавные буквы, строчные буквы, цифры, символы",
        "newpassempty": "Новый пароль не может быть пустым",
        "newpass": "Пароли не совпадают",
        "getcode": "Получить код подтверждения",
        "format": "Неверный формат номера телефона",
        "chongfa": "Повторная отправка через {seconds} сек.",
        "isSend": "Отправлено",
        "noregister": "Нет аккаунта? Зарегистрируйтесь сейчас",
        "Mobile": "Номер телефона",
        "verificationcode": "Код подтверждения",
        "petname": "Псевдоним",
        "Quickregistration": "Быстрая регистрация",
        "xiugaimima": "Сменить пароль",
        "jiumima": "Старый пароль",
        "xinmima": "Новый пароль",
        "zaicishuruxinmima": "Повторите новый пароль",
        "xiugaichenggong": "Изменено успешно",
        "xiugaishoujihao": "Сменить номер телефона",
        "dengluzhanghao": "Логин",
        "gongsiid": "ID компании",
        "yonghunicheng": "Псевдоним пользователя",
        "chuangjianshijian": "Дата создания",
        "gongsimingcheng": "Название компании",
        "denglumima": "Пароль для входа",
        "jianyi": "Рекомендуется использовать пароль из букв и цифр",
        "shezhimima": "Установить пароль",
        "shezhishoujihao": "Сменить/установить номер телефона",
        "yibangding": "Привязано",
        "weibangding": "Не привязано",
        "zhanghuanquan": "Безопасность аккаунта",
        "yonghuxinxi": "Информация о пользователе",
        "zhuceSucMsg": "Поздравляем, регистрация успешна!",
        "verificationcodeSucMsg": "Код подтверждения отправлен успешно!",
        "requiredIsEmpty": "Обязательные поля не могут быть пустыми!",
        "emailObj": {
            "title": "Эл. почта",
            "tit": "Вход по эл. почте",
            "tip": "Пожалуйста, введите адрес эл. почты",
            "formatTip": "Пожалуйста, введите корректный адрес эл. почты"
        },
        "phoneObj": {
            "title": "Телефон",
            "tit": "Вход по телефону",
            "tip": "Пожалуйста, введите номер телефона",
            "formatTip": "Пожалуйста, введите номер телефона в правильном формате"
        },
        "emailOrPhoneObj": {
            "title": "Эл. почта или телефон",
            "tit": "Вход по эл. почте или телефону",
            "tip": "Пожалуйста, введите эл. почту или номер телефона",
            "formatTip": "Пожалуйста, введите корректный адрес эл. почты или номер телефона"
        },
        "wechatObj": {
            "title": "WeChat",
            "tit": "Вход через WeChat"
        },
        "googleObj": {
            "title": "Google",
            "tit": "Вход через Google"
        },
        "confirm": "Подтвердить",
        "confirmSubmit": "Отправить",
        "cancel": "Отменить",
        "close": "Закрыть",
        "bindSucMsg": "Привязка успешна",
        "toContinueBindAccount": "Продолжить для завершения привязки аккаунта третьей стороны",
        "bindTip01": "Нет аккаунта? Создайте его",
        "bindTip02": "Уже есть аккаунт",
        "bindTip03": "Текущий аккаунт третьей стороны не привязан к аккаунту платформы. Пожалуйста, привяжите существующий аккаунт или зарегистрируйте и привяжите новый, чтобы в следующий раз войти быстро.",
        "bindTip04": "Привязать существующий аккаунт",
        "bindTip05": "Зарегистрировать и привязать новый аккаунт",
        "bindTip06": "Вы авторизованы через третью сторону. Заполните следующие данные для завершения привязки",
        "bindSubmit": "Отправить привязку",
        "enterAccountTip": "Пожалуйста, введите название аккаунта",
        "RegisterAndBind": "Зарегистрировать и привязать",
        "loginErr": "Неверное имя пользователя или пароль!",
        "usercenter": "Личный кабинет",
        "pleaseInputName": "Пожалуйста, введите название",
        "operationSuccess": "Операция выполнена успешно!",
        "edit": "Редактировать",
        "xiugai": "Изменить",
        "userData": "Личные данные",
        "changePassword": "Смена пароля",
        "account": "Аккаунт",
        "userName01": "Имя пользователя",
        "phoneNumber": "Номер телефона",
        "role": "Роль",
        "createTime": "Дата создания",
        "genghuang": "Сменить",
        "bangding": "Привязать",
        "unbind": "Отвязать",
        "plesaseSelectBindingType": "Пожалуйста, выберите тип привязки",
        "pleaseConfirmCont": "Пожалуйста, подтвердите, что вы прочитали этот текст",
        "confirmReadCont": "Я прочитал(а) этот текст",
        "frequentTip": "Операции выполняются слишком часто, попробуйте позже!",
        "zhuxiaoBtn": "Удалить аккаунт",
        "zhuxiaoTitle": "Удаление аккаунта",
        "querenZhuxiao": "Подтвердить удаление",
        "jiXu": "Продолжить",
        "sendCodeBtn": "Отправить код подтверждения",
        "passwordIsNotOldPassword": "Подтверждение пароля не совпадает с новым паролем",
        "passwordIsOldPassword": "Новый пароль совпадает с старым",
        "passFormatError": "Пожалуйста, введите пароль в правильном формате",
        "oldPassWord": "Старый пароль",
        "newPassWord": "Новый пароль",
        "inputPlaceholder": "Пожалуйста, введите",
        "confirmPassword": "Подтвердить пароль",
        "zhuxiaoTip": `
            1、Удаление аккаунта — необратимая операция. После удаления вы не сможете войти и использовать этот аккаунт или аккаунты третьих сторон, зарегистрированные через него. Сделайте резервную копию всех данных самостоятельно.
            2、Перед удалением аккаунта убедитесь, что все активы очищены и нет споров. После удаления вы теряете все права на активы и привилегии в аккаунте, восстановление невозможно.
            3、Если по одному номеру телефона было удалено 3 и более аккаунтов, этот номер нельзя будет использовать для регистрации новых аккаунтов и привязки к другим аккаунтам.
        `
    },
    "home": {
        "title": "Главная",
        "quickOperation": "Быстрые действия",
        "addDevice": "Добавить устройство",
        "publishProgram": "Опубликовать программу",
        "publishMaterial": "Опубликовать материалы",
        "makeProgram": "Создать программу",
        "uploadMaterial": "Загрузить материалы",
        "todayData": "Данные за сегодня (обновляются каждый час)",
        "playNumChart": "Статистика количества воспроизведений",
        "deviceOnlineStatus": "Статус устройств",
        "onLineDevice": "Онлайн-устройства",
        "unLineDevice": "Оффлайн-устройства",
        "programPlayTime": "Статистика времени воспроизведения программ",
        "downloadSoft": "Скачать программное обеспечение",
        "adminApp": "Мобильное приложение для администратора",
        "playerApp": "Терминал воспроизведения информации",
        "downloadAdminApp": "Нажмите для скачивания приложения администратора",
        "downloadPlayerApp": "Нажмите для скачивания плеера",
        "aboutUs": "О нас",
        "userManual": "Руководство пользователя",
        "message": "Оставить сообщение"
    },
    "device": {
        "inputPlaceholder": "Пожалуйста, введите",
        "selectPlaceholder": "Пожалуйста, выберите",
        "osTypeStr": "Операционная система терминала",
        "onLineStatus": "Статус подключения",
        "dpi": "Разрешение",
        "companyDeptIdName": "Принадлежащая организация",
        "deviceGroupIdName": "Принадлежащая группа",
        "editOrMove": "Редактировать/переместить",
        "loanOriginationFee": "Комиссия за выдачу кредита",
        "strategyInfoLook": "Просмотр информации о стратегии",
        "programLook": "Просмотр программ",
        "addEquipments": "Добавить устройства",
        "luminanceSet": "Управление яркостью",
        "terminal": "Настройки терминала",
        "transferCompany": "Перевести в другой отдел",
        "releasedProgram": "Опубликовать программу",
        "screenshot": "Сделать скриншот",
        "changeGroup": "Изменить группу",
        "defaultGroup": "Группа по умолчанию",
        "operation": "Действия",
        "edit": "Редактировать",
        "saveEdit": "Сохранить изменения",
        "add": "Добавить",
        "save": "Сохранить",
        "setting": "Настройки",
        "program": "Программа",
        "unbind": "Отвязать",
        "sleep": "Спящий режим",
        "wakeup": "Разбудить",
        "restart": "Перезагрузить",
        "shutdown": "Выключить",
        "reportLog": "Отправить логи",
        "clearPlayData": "Очистить данные плеера",
        "offlineWarn": "Устройство оффлайн, попробуйте снова после подключения!",
        "confirmUnbind": "Подтвердить отвязку",
        "confirmReset": "Подтвердить очистку",
        "confirmDelete": "Подтвердить удаление",
        "delete": "Удалить",
        "cancelDelete": "Отменить удаление",
        "confirmResetSuccess": "Очищено успешно",
        "confirm": "Подтвердить",
        "cancel": "Отменить",
        "operationSuccess": "Операция выполнена успешно",
        "unbindSuccess": "Отвязка успешна",
        "pleaseSelectDevice": "Пожалуйста, выберите устройство",
        "pleaseSelectOnlineDevice": "Пожалуйста, выберите онлайн-устройство",
        "confirmMixOperation": "В выбранных устройствах есть оффлайн-устройства, на них настройка не применится. Продолжить?",
        "pleaseSelectDate": "Пожалуйста, выберите дату",
        "reportSuccess": "Отправлено успешно",
        "deviceSetting": "Настройки устройства",
        "default": "По умолчанию",
        "all": "Все",
        "deviceList": "Список устройств",
        "addDevice": "Добавить устройство",
        "department": "Организационная структура",
        "deviceType": "Разрешение",
        "osType": "Операционная система терминала",
        "onlineState": "Статус подключения",
        "online": "Онлайн",
        "offline": "Оффлайн",
        "notActive": "Не активировано",
        "search": "Пожалуйста, введите ключевые слова",
        "batchOperation": "Групповые операции",
        "allDevices": "Все устройства",
        "deviceAttribute": "Атрибуты устройства",
        "selectReportDate": "Выбрать дату отчета",
        "inputName": "Пожалуйста, введите название",
        "inputWidth": "Пожалуйста, введите ширину",
        "inputHeight": "Пожалуйста, введите высоту",
        "inputResolutionRatio": "Пожалуйста, введите целое число больше 0!",
        "inputSort": "Пожалуйста, введите порядок сортировки",
        "serialNum": "Порядковый номер",
        "name": "Название",
        "width": "Ширина",
        "height": "Высота",
        "resolutionRatio": "Разрешение",
        "inputResolutionRatioName": "Пожалуйста, введите название разрешения",
        "sort": "Порядок",
        "personal": "Личный",
        "system": "Системный",
        "type": "Тип",
        "systemDefaultSettingUneditable": "Системные настройки по умолчанию не редактируются!",
        "systemDefaultSettingUnDeletable": "Системные настройки по умолчанию не удаляются!",
        "newz": "Добавить",
        "total": "Всего",
        "totalNum": "шт.",
        "strategyName": "Название стратегии",
        "associatedTerminalNum": "Количество связанных терминалов",
        "createTime": "Дата создания",
        "pleaseSelectStrategy": "Пожалуйста, выберите стратегию!",
        "onlySelectOneData": "Можно выбрать только одну запись!",
        "downloadStrategy": "Скачать стратегию",
        "inputStrategyName": "Пожалуйста, введите название стратегии",
        "luminanceControl": "Управление яркостью",
        "volumeStrategy": "Стратегия громкости",
        "saveSuccess": "Сохранено успешно",
        "screenAngle": "Поворот экрана (°)",
        "startTime": "Время начала",
        "endTime": "Время окончания",
        "repeat": "Повторять",
        "monday": "Понедельник",
        "tuesday": "Вторник",
        "wednesday": "Среда",
        "thursday": "Четверг",
        "friday": "Пятница",
        "saturday": "Суббота",
        "sunday": "Воскресенье",
        "everyday": "Каждый день",
        "downloadSpeed": "Скорость загрузки",
        "inputDownloadSpeed": "Пожалуйста, введите скорость загрузки",
        "operator": "Действия",
        "pleaseSelectDeleteData": "Пожалуйста, выберите данные для удаления!",
        "confirmBatchDelete": "Подтвердить групповое удаление?",
        "pleaseInputName": "Пожалуйста, введите название",
        "detailSetting": "Детальные настройки",
        "weekPlan": "Недельный план",
        "specialDateSetting": "Настройки для особых дат",
        "weekdayInfo": "День недели — обязательное поле!",
        "volumeInfo": "Громкость — обязательное поле!",
        "timeError": "Неверный выбор времени!",
        "editSuccess": "Редактирование выполнено успешно!",
        "addSuccess": "Добавление выполнено успешно!",
        "addSpecialPlan": "Добавить специальный план стратегии",
        "downloadSpeedInfo": "Скорость загрузки: (0 — загрузка запрещена)",
        "pleaseSelectStartTime": "Пожалуйста, выберите время начала",
        "pleaseSelectEndTime": "Пожалуйста, выберите время окончания",
        "luminanceError": "Пожалуйста, введите корректное значение яркости!",
        "defaultLuminance": "Яркость по умолчанию",
        "luminance": "Уровень яркости",
        "defaultLuminanceInfo": "Яркость по умолчанию (100 — максимальная, 0 — минимальная)",
        "volume": "Громкость",
        "saveLuminance": "Сохранить яркость",
        "changeSuccess": "Изменено успешно!",
        "changeNetwork": "Сменить сеть",
        "netName": "Название сети",
        "nameempty": "Название сети не может быть пустым",
        "currentNetwork": "Текущая сеть",
        "ipAddress": "IP-адрес",
        "dailyMode": "Ежедневный режим",
        "weeklyMode": "Недельный режим",
        "turnOnTime": "Время включения",
        "turnOffTime": "Время выключения",
        "startSleep": "Начало спящего режима",
        "endSleep": "Конец спящего режима",
        "batchDelInfo": "Подтвердить удаление выбранных элементов?",
        "timeCannotBeEmpty": "Время не может быть пустым!",
        "startUp": "Включить",
        "shutDown": "Выключить",
        "volumeSize": "Уровень громкости",
        "defaultVolume": "Громкость по умолчанию (100 — максимальная, 0 — без звука)",
        "chooseStartTime": "Пожалуйста, выберите время начала",
        "chooseEndTime": "Пожалуйста, выберите время окончания",
        "saveVolume": "Сохранить громкость",
        "screenRotationUnSaved": "Поворот экрана не сохранен",
        "volumeSettingUnSaved": "Настройки громкости не сохранены",
        "luminanceSettingUnSaved": "Настройки яркости не сохранены",
        "confirmClosePopup": "Подтвердить закрытие этого окна?",
        "volumeSettingSuccess": "Громкость изменена успешно",
        "luminanceSettingSuccess": "Яркость изменена успешно",
        "advancedSettingUnSaved": "Расширенные настройки не сохранены",
        "settingTitle": "Настройки терминала",
        "volumeSetting": "Настройки громкости",
        "luminanceSetting": "Настройки яркости",
        "downloadSetting": "Настройки загрузки",
        "sleepSetting": "Настройки спящего режима",
        "onOffSetting": "Планирование включения/выключения",
        "screenRotation": "Поворот экрана",
        "namingError": "Ошибка наименования: имя файла не может содержать пробелы!",
        "deleteSuccess": "Удалено успешно",
        "deleteFolder": "Удалить папку",
        "pleaseInputDeviceName": "Пожалуйста, введите название устройства",
        "pleaseInputDeviceId": "Пожалуйста, введите ID устройства",
        "discoverDevice": "Обнаружить устройства",
        "deviceId": "ID устройства",
        "bound": "Привязано",
        "bind": "Привязать",
        "noDevice": "Устройства отсутствуют",
        "refresh": "Обновить",
        "manualAdd": "Добавить вручную",
        "deviceGroup": "Категория устройств",
        "pleaseSelectGroup": "Пожалуйста, выберите группу!",
        "deviceName": "Название устройства",
        "goAdd": "Перейти к добавлению",
        "close": "Закрыть",
        "bindCountInsufficient": "Недостаточно доступных привязок, увеличьте количество устройств перед добавлением!",
        "displayNumber": "Номер отображения",
        "groupName": "Название группы",
        "pleaseSelectGroupName": "Пожалуйста, заполните название группы!",
        "moveGroup": "Переместить группу",
        "longitude": "Долгота",
        "latitude": "Широта",
        "nationality": "Национальность",
        "province": "Провинция",
        "city": "Город",
        "county": "Район",
        "outNetIp": "Внешний IP",
        "inNetIp": "Внутренний IP",
        "companyName": "Название компании",
        "Info": "Детали",
        "android": "Android",
        "win": "Windows",
        "osVersion": "Версия ОС",
        "softwareVersion": "Версия ПО",
        "diskSize": "Размер диска",
        "useSize": "Использовано места",
        "macAddr": "MAC-адрес",
        "longitudeLatitudeInfo": "Долгота и широта должны быть заполнены одновременно или быть пустыми!",
        "terminalName": "Название терминала",
        "terminalGroup": "Группа терминалов",
        "reportJournal": "Отправлять отчеты?",
        "systemVersion": "Версия ОС",
        "storageSpace": "Память хранения",
        "resolution": "Разрешение",
        "runningMemory": "Оперативная память",
        "model": "Модель",
        "registerStatus": "Статус регистрации",
        "password": "Пароль",
        "passwordInfo": "Пожалуйста, введите от 6 до 18 букв или цифр!",
        "group": "Группа",
        "address": "Адрес",
        "remark": "Примечание",
        "renewalPeriod": "Период продления",
        "money": "Сумма",
        "latitudeInfo": "Пожалуйста, введите корректную широту!",
        "totalPayment": "Общая сумма",
        "longitudeInfo": "Пожалуйста, введите корректную долготу!",
        "setMeal": "Тарифный план",
        "number": "Количество",
        "programName": "Название программы",
        "playStatus": "Статус воспроизведения",
        "playType": "Способ воспроизведения",
        "play": "Воспроизвести",
        "pause": "Приостановить",
        "playTime": "Время воспроизведения",
        "programDeleted": "Программа удалена",
        "playSuccess": "Программа запланирована к воспроизведению",
        "pauseSuccess": "Приостановлено успешно",
        "playCycle": "Циклическое воспроизведение",
        "playInsert": "Вставное воспроизведение",
        "withdrawSuccess": "Отозвано успешно",
        "withdrawInfo": "Пожалуйста, сначала выберите программу для отзыва!",
        "programBelong": "Принадлежащая программа",
        "checkAll": "Выбрать все",
        "batchDel": "Групповое удаление",
        "delConfirm": "Подтвердить удаление выбранных элементов?",
        "check": "Выбрано",
        "noProgram": "Программы отсутствуют",
        "details": "Детали",
        "screenshotFail": "Ошибка создания скриншота",
        "policyName": "Название политики",
        "terminalNum": "Количество связанных терминалов",
        "powerStrategy": "Стратегия питания",
        "pleaseSelectDepartment": "Пожалуйста, выберите отдел!",
        "screenshotControl": "Управление скриншотами",
        "未激活": "Не активировано",
        "已激活": "Активировано",
        "未绑定": "Не привязано",
        "已绑定": "Привязано"
    },
    "programManage": {
        "programList": "Список программ",
        "publishProgram": "История публикации программ",
        "week1": "Понедельник",
        "week2": "Вторник",
        "week3": "Среда",
        "week4": "Четверг",
        "week5": "Пятница",
        "week6": "Суббота",
        "week7": "Воскресенье",
        "monday": "Понедельник",
        "tuesday": "Вторник",
        "wednesday": "Среда",
        "thursday": "Четверг",
        "friday": "Пятница",
        "saturday": "Суббота",
        "sunday": "Воскресенье",
        "name": "Название",
        "preview": "Предпросмотр",
        "playDeviceNum": "Количество устройств воспроизведения",
        "copyDeviceCode": "Нажмите для копирования",
        "osType": "Тип ОС",
        "playDate": "Дата воспроизведения",
        "playWeek": "Неделя воспроизведения",
        "everyday": "Каждый день",
        "start": "От",
        "end": "До",
        "playOperateStatusStr": "Статус публикации",
        "playDevice": "Устройство воспроизведения",
        "downloadView": "Просмотр загрузок",
        "publisher": "Опубликовавший",
        "publishTime": "Время публикации",
        "operation": "Действия",
        "add": "Добавить",
        "groupName": "Название группы",
        "selectDevice": "Выбрать терминал",
        "searchDevice": "Поиск терминала",
        "pleaseFillGroupName": "Пожалуйста, заполните название группы!",
        "remarkInfo": "Примечание",
        "compile": "Редактировать",
        "withdrawConfirm": "Подтвердить отзыв этой программы?",
        "confirm": "Подтвердить",
        "cancel": "Отменить",
        "withdraw": "Отозвать",
        "batchWithdraw": "Групповой отзыв",
        "batchPublish": "Групповая публикация",
        "batchDelete": "Групповое удаление",
        "batchOperation": "Групповые операции",
        "notUse": "Не используется",
        "notChecked": "Не проверено",
        "notPass": "Не утверждено",
        "delete": "Удалить",
        "publishTextLeft": "Опубликовано",
        "offTextLeft": "Приостановлено",
        "pleaseSelectProgramToMove": "Пожалуйста, выберите программу для перемещения!",
        "pause": "Приостановить",
        "pauseConfirm": "Подтвердить приостановку?",
        "play": "Воспроизвести",
        "downloadUdisk": "Скачать на флеш-накопитель",
        "deviceList": "Список устройств",
        "groupSelection": "Выбор группы",
        "operationSuccess": "Операция выполнена успешно",
        "deleteSuccess": "Удалено успешно",
        "selectDate": "Выбрать дату",
        "publishStatus": "Статус публикации",
        "checkStatus": "Статус проверки",
        "waitAuditing": "На проверке",
        "auditPass": "Проверка пройдена",
        "auditRefuse": "Проверка отклонена",
        "all": "Все",
        "playStatus": "Воспроизводится",
        "playStatust": "Статус воспроизведения",
        "pauseStatus": "Приостановлено",
        "notStartStatus": "Не начато",
        "resolutionratio": "Разрешение",
        "totalNum": "шт.",
        "programName": "Название программы",
        "playStartTime": "Время начала воспроизведения",
        "playEndTime": "Время окончания воспроизведения",
        "createTime": "Дата создания",
        "nationality": "Национальность",
        "province": "Провинция",
        "city": "Город",
        "county": "Район",
        "address": "Адрес",
        "ip": "IP-адрес",
        "location": "Местоположение",
        "log": "Логи",
        "pleaseFillProgramName": "Пожалуйста, заполните название программы!",
        "selectGroup": "Выбрать группу",
        "startTime": "Время начала",
        "endTime": "Время окончания",
        "publishCycle": "Период публикации",
        "publishDeviceNum": "Количество опубликованных устройств",
        "pleaseSelectRecord": "Пожалуйста, выберите запись",
        "deviceName": "Название терминала",
        "deviceId": "ID терминала",
        "deviceGroupIdName": "Принадлежащая группа",
        "notClassified": "Не классифицировано",
        "osTypeStr": "Операционная система терминала",
        "storageSpace": "Память хранения",
        "onLineStatus": "Статус подключения",
        "onLine": "Онлайн",
        "offLine": "Оффлайн",
        "sleep": "Спящий режим",
        "unknown": "Неизвестно",
        "registerStatus": "Статус регистрации",
        "trialPeriod": "Пробный период",
        "notActive": "Не активировано",
        "active": "Активировано",
        "parameterError": "Неверные параметры!",
        "pleaseSelectProgram": "Пожалуйста, выберите программу!",
        "pleaseSelectProgramEdit": "Пожалуйста, выберите программу для редактирования!",
        "confirmWithdrawSelectedProgram": "Подтвердить отзыв выбранных программ?",
        "withdrawSuccess": "Отозвано успешно",
        "allPrograms": "Все программы",
        "defaultGroup": "Группа по умолчанию",
        "cannotShareEmptyProgram": "Невозможно поделиться пустой программой!",
        "onlyShareYourProgram": "Можно поделиться только программами, созданными вами!",
        "pleaseSelectProgramEditPublishTime": "Пожалуйста, выберите программу с отредактированным временем публикации!",
        "pleaseSelectDevice": "Пожалуйста, выберите устройство!",
        "programDetail": "Детали программы",
        "errorReason": "Причина ошибки",
        "availableStorageSpaceInsufficient": "Недостаточно свободного места для хранения",
        "partialDeviceReleaseFailure": "Опубликование на некоторых устройствах не удалось",
        "allDeviceReleaseSuccess": "Опубликование на всех устройствах успешно",
        "partialDeviceReleaseSuccess": "Опубликование на некоторых устройствах успешно",
        "allGroup": "Все группы",
        "allProgram": "Все программы",
        "unGrouped": "Не сгруппировано",
        "replaceProgram": "Заменить программу",
        "replaceProgramTip": "Новая опубликованная программа заменит существующие данные программ на терминале воспроизведения!",
        "screen": "Один/два экрана",
        "singleScreen": "Один экран",
        "doubleScreen": "Два экрана",
        "playSetting": "Настройки воспроизведения",
        "batchPlaySetting": "Групповая настройка времени воспроизведения",
        "individualPlaySetting": "Индивидуальная настройка времени воспроизведения",
        "playTime": "Время воспроизведения",
        "daily": "Ежедневно",
        "weekdays": "Понедельник-пятница",
        "monthly": "Текущий месяц",
        "advancedSetting": "Расширенные настройки",
        "playProgram": "Воспроизвести программу",
        "searchProgram": "Пожалуйста, введите ключевые слова",
        "shareAddressNotExist": "Ссылка не существует, попробуйте снова",
        "copySuccess": "Скопировано успешно",
        "shareLink": "Ссылка для обмена",
        "publish": "Опубликовать",
        "noResource": "Ресурсы отсутствуют",
        "single": "Один экран",
        "double": "Два экрана",
        "time": "Время",
        "associatedTerminalNum": "Количество связанных терминалов",
        "default": "По умолчанию",
        "moveGroup": "Переместить группу",
        "pleaseSelectGroup": "Пожалуйста, заполните название группы!",
        "copy": "Копировать",
        "FUBEN": "Копия",
        "nameempty": "Название не может быть пустым",
        "whitespace": "Ошибка наименования: имя файла не может содержать пробелы!",
        "programWhitespace": "Ошибка наименования: название программы не может содержать пробелы!",
        "pleaseSelectResolution": "Пожалуйста, выберите разрешение!",
        "dataError": "Неверные данные!",
        "createProgram": "Создать новую программу",
        "directCreate": "Создать напрямую",
        "myTemplate": "Мои шаблоны",
        "use": "Использовать",
        "free": "Бесплатно",
        "loadMore": "Загрузить больше",
        "confirmDelete": "Подтвердить удаление",
        "deleteGroup": "Удалить группу",
        "notPublished": "Не опубликовано",
        "notPassed": "Не утверждено",
        "notUsed": "Не используется",
        "confirmDeleteSelectedProgram": "Подтвердить удаление выбранных программ?",
        "companyName": "Название компании",
        "programCannotDownload": "Эта программа не может быть скачана!",
        "publishMaterial": "Опубликовать материалы",
        "playMaterial": "Воспроизвести материалы",
        "pleaseInputMaterialName": "Пожалуйста, введите название материала",
        "size": "Размер",
        "pleaseInputDeviceName": "Пожалуйста, введите название устройства",
        "item": "шт.",
        "allMaterial": "Все материалы",
        "allDevices": "Все устройства",
        "saveSuccess": "Сохранено успешно",
        "savefaill": "Ошибка сохранения",
        "playMode": "Режим воспроизведения",
        "cyclePlay": "Циклическое воспроизведение",
        "insertPlay": "Вставное воспроизведение",
        "noData": "Данных нет",
        "Add": "Добавить",
        "replace": "Заменить",
        "repeat": "Повторить",
        "start01": "Начало",
        "end01": "Конец",
        "startDate": "Дата начала",
        "endDate": "Дата окончания",
        "useNow": "Использовать сразу",
        "fillStartEndTimeFirst": "Пожалуйста, заполните время начала и окончания перед добавлением",
        "fillFullPlayTime": "Пожалуйста, заполните полное время воспроизведения",
        "fillCorrectPlayTime": "Пожалуйста, заполните правильный период воспроизведения",
        "sDateAndEDateBothEmptyOrFilled": "Дата начала и дата окончания должны быть либо обе пустыми, либо обе заполненными"
    },
    "source": {
        "addResource": "Добавление ресурса",
        "width": "Ширина",
        "height": "Высота",
        "size": "Размер (КБ)",
        "name": "Название",
        "pleaseInputResourceName": "Пожалуйста, введите название ресурса!",
        "addToGroup": "Добавить в группу",
        "remark": "Примечание",
        "promptFgIllustrate": "Иллюстрация",
        "promptFgRealisticPhoto": "Реалистичное фото",
        "promptFgSimplisticDrawing": "Легкий рисунок",
        "promptFgChineseStyle": "Китайский стиль",
        "promptFgPixelArt": "Пиксель-арт",
        "noModel": "Моделей нет, обратитесь к администратору!",
        "getModelFailed": "Не удалось получить модель, попробуйте позже! Или обратитесь к администратору!",
        "createImagePrompt": "Изображение генерируется, пожалуйста, не закрывайте окно!",
        "promptEmpty": "Пожалуйста, введите промпт",
        "dpiEmpty": "Пожалуйста, выберите соотношение сторон изображения!",
        "fgEmpty": "Пожалуйста, выберите стиль!",
        "style": "Стиль",
        "idEmpty": "ID изображения не может быть пустым",
        "exist": "Это изображение уже есть в материалах",
        "addSuccess": "Материал добавлен успешно",
        "saveError": "Не удалось сохранить изображение, попробуйте позже!",
        "delSuccess": "Удалено успешно",
        "generateImage": "Текст в изображение",
        "generateImagePlaceholder": "Введите описание желаемого изображения, например: Бабочка танцует среди цветов",
        "aiExpand": "Интеллектуальное расширение",
        "negativePrompt": "Негативный промпт",
        "negativePromptTooltip": "Используется для явного исключения контента или характеристик, которые пользователь не хочет видеть в результате",
        "imageRatio": "Соотношение сторон изображения",
        "generateImageBtn": "Сгенерировать сейчас",
        "shengchengjieguo": "Результат генерации",
        "generateImageLoadingTip": "Генерация в процессе, не нажимайте повторно и не закрывайте окно...",
        "Tooltip": "Реализуйте свои идеи с помощью ИИ",
        "saveToMaterial": "Сохранить в материалы",
        "publish": "Опубликовать сейчас",
        "download": "Скачать",
        "generateHistory": "История генерации",
        "hide": "Свернуть",
        "cancel": "Отменить",
        "useExpand": "Использовать расширенный вариант",
        "all": "Все",
        "delete": "Удалить",
        "loadMore": "Загрузить больше",
        "aiTip": "Контент создан искусственной интеллектуальной моделью и не отражает позицию или мнение платформы. Используйте ИИ-контент в соответствии с правилами и законодательством",
        "operationSuccess": "Операция выполнена успешно",
        "moveGroup": "Переместить в группу",
        "groupName": "Название группы",
        "pleaseSelectGroup": "Пожалуйста, выберите название группы!",
        "shenhe": "Проверка",
        "shenheStatus": "Статус проверки",
        "shenheSuccess": "Проверка пройдена",
        "shenheRefuse": "Проверка отклонена",
        "pleaseSelectShenheStatus": "Пожалуйста, выберите статус проверки!",
        "shenheRemark": "Примечание к проверке",
        "pleaseInputShenheRemark": "Пожалуйста, введите примечание к проверке!",
        "pleaseInputFileName": "Пожалуйста, введите имя файла!",
        "whitespace": "Ошибка именования: имя файла не может содержать пробелы!",
        "dataError": "Неверные данные!",
        "confirmDelete": "Подтвердить удаление",
        "confirm": "Подтвердить",
        "deleteFolder": "Удалить папку",
        "add": "Добавить",
        "edit": "Редактировать",
        "fileName": "Имя файла",
        "group": "Группа",
        "resolution": "Разрешение",
        "type": "Тип",
        "image": "Изображение",
        "music": "Музыка",
        "video": "Видео",
        "uploadTime": "Время загрузки",
        "uploadUser": "Загрузил",
        "checkTime": "Время проверки",
        "checkUser": "Проверил"
    },
    "setting": {
        "nameempty": "Название не может быть пустым",
        "heightempty": "Высота не может быть пустой",
        "widthempty": "Ширина не может быть пустой",
        "resolutionratio": "Разрешение",
        "name": "Название",
        "opteration": "Действия",
        "compile": "Редактировать",
        "delete": "Удалить",
        "newz": "Добавить",
        "compileratio": "Редактировать разрешение",
        "sheizhifenbianlvmingcheng": "Установить название разрешения",
        "shezhigaodu": "Установить высоту",
        "shezhikuandu": "Установить ширину",
        "xinzengfenbianlv": "Добавить разрешение",
        "bianma": "Кодировка",
        "bianjizhongduanmingcheng": "Редактировать название терминала",
        "xinzengzhongduan": "Добавить терминал",
        "selectPrimaryColor": "Выбрать основной цвет темы",
        "fullScreen": "На весь экран",
        "exitFullScreen": "Выйти из полноэкранного режима"
    },
    "tabs": {
        "refresh": "Обновить",
        "refreshAll": "Обновить все",
        "close": "Закрыть",
        "closeOthers": "Закрыть другие",
        "closeAll": "Закрыть все",
        "closeLeft": "Закрыть левые",
        "closeRight": "Закрыть правые"
    },
    "errorPage": {
        "needLogin": "Вы еще не авторизованы!",
        "pageNotFound": "Запрашиваемая страница не существует!",
        "redirectTo": "Перенаправление на",
        "orReturn": "или вернуться к",
        "previousStep": "предыдущему шагу"
    },
    "headerUs": {
        "systemNotice": "Системные уведомления",
        "allNotices": "Все уведомления",
        "viewAllMessages": "Просмотреть все сообщения",
        "contactUs": "Связаться с нами",
        "operationSuccess": "Операция выполнена успешно!",
        "leaveMessage": "Оставить сообщение",
        "messageTitle": "Заголовок",
        "messageTitleTip": "Пожалуйста, введите заголовок!",
        "messageContentTip": "Не более 150 символов",
        "submit": "Отправить",
        "markAsRead": "Отметить как прочитанное",
        "success": "Операция выполнена успешно!"
    },
    "material": {
        "allMaterial": "Все материалы",
        "defaultGroup": "Группа по умолчанию",
        "auditStatus": "Статус проверки",
        "auditPassed": "Проверка пройдена",
        "auditRejected": "Проверка отклонена",
        "pendingAudit": "На проверке",
        "all": "Все",
        "operateSuccess": "Операция выполнена успешно!",
        "pleaseSelectMaterial": "Пожалуйста, выберите материал!",
        "moveGroup": "Переместить в группу",
        "pleaseSelectGroup": "Пожалуйста, выберите группу!",
        "batchPublish": "Групповая публикация",
        "batchRecall": "Групповый отзыв",
        "batchDelete": "Групповое удаление",
        "materialList": "Список материалов",
        "uploadMaterial": "Загрузить материалы",
        "materialType": "Тип материала",
        "pleaseInputMaterialName": "Пожалуйста, введите название материала",
        "selectAll": "Выбрать все",
        "confirmDeleteSelectedMaterial": "Подтвердить удаление выбранных материалов?",
        "deleteSuccess": "Удалено успешно",
        "delete": "Удалить",
        "publish": "Опубликовать",
        "recall": "Отозвать",
        "confirmRecallSelectedMaterial": "Подтвердить отзыв выбранных материалов?",
        "pleaseSelectMaterialGroup": "Пожалуйста, выберите группу материалов!",
        "recallSuccess": "Отозвано успешно",
        "publishSuccess": "Опубликовано успешно",
        "batchOperate": "Групповые действия",
        "item": "шт.",
        "confirmDelete": "Подтвердить удаление?",
        "edit": "Редактировать",
        "confirmRecall": "Подтвердить отзыв?",
        "unaudited": "Не проверено",
        "notPassed": "Не утверждено",
        "operate": "Действия",
        "resolution": "Разрешение",
        "none": "Отсутствует",
        "confirm": "Подтвердить",
        "cancel": "Отменить",
        "AICreation": "Создание ИИ"
    },
    "uploadFile": {
        "operationSuccess": "Операция выполнена успешно",
        "uploadFile": "Управление загрузкой",
        "uploadSuccess": "Загрузка успешна",
        "uploadCompleted": "Загрузка завершена",
        "uploadFail": "Загрузка не удалась",
        "ConversionFailed": "Конвертация не удалась!",
        "loading": "Загрузка в процессе...",
        "beQueuing": "В очереди...",
        "Uploading": "Загрузка...",
        "ConversionIng": "Конвертация...",
        "ConventionalResources": "Стандартные ресурсы",
        "DocumentResources": "Документные ресурсы",
        "complete": "Завершено",
        "upload": "Загрузить",
        "fileSizeWraning01": "Размер материала превысил лимит",
        "fileSizeWraning02": "Измените размер и попробуйте загрузить снова!",
        "fileIsEmpty": "Файл пустой",
        "uploadFileTip": "Неподдерживаемый формат файла",
        "unablePreview": "Не удалось добавить в библиотеку материалов, предварительный просмотр невозможен",
        "confirmDelete": "Подтвердить удаление?",
        "deleteSuccess": "Удалено успешно",
        "delete": "Удалить",
        "confirm": "Подтвердить",
        "preview": "Предпросмотр",
        "close": "Закрыть",
        "cancel": "Отменить",
        "fileType": "Тип файла",
        "fileSize": "Размер файла",
        "conversionProgress": "Прогресс конвертации",
        "progress": "Прогресс",
        "image": "Изображение",
        "video": "Видео",
        "audio": "Музыка",
        "limitTip01": "Одновременно можно загрузить",
        "limitTip02": "файлов",
        "okTip": "Материалы загружаются, пожалуйста, не закрывайте окно!",
        "usableSize": "Доступное пространство",
        "sizeUnableTip": "Недостаточно доступного места для хранения. Очистите неиспользуемые материалы или обратитесь к дистрибьютору для расширения объема хранилища.",
        "view": "Просмотреть детали",
        "fileName": "Имя файла"
    },
    "template": {
        "inputPlaceholder": "Пожалуйста, введите",
        "selectPlaceholder": "Пожалуйста, выберите",
        "noAuths": "Нет прав доступа, обратитесь к администратору",
        "operationSuccess": "Операция выполнена успешно",
        "total": "Всего",
        "totalNum": "шт.",
        "dan": "Один",
        "shaung": "Два",
        "pleaseSelectGroup": "Пожалуйста, выберите группу",
        "preview": "Предпросмотр",
        "free": "Бесплатно",
        "use": "Использовать",
        "dpi": "Разрешение",
        "delete": "Удалить",
        "confirmDelete": "Подтвердить удаление",
        "confirmDeleteSelectedTemplate": "Подтвердить удаление этого шаблона?",
        "push": "Опубликовать",
        "pushConfirm": "Подтвердить публикацию в общедоступные шаблоны?",
        "pushRemovalConfirm": "Подтвердить снятие с общедоступных шаблонов?",
        "templateOrderRecord": "История заказов шаблонов",
        "unpublished": "Не опубликовано",
        "auditing": "На проверке",
        "publishRejected": "Публикация отклонена",
        "publishSuccess": "Опубликовано успешно",
        "offShelf": "Снять с публикации",
        "公共模版": "Общедоступные шаблоны",
        "我的模板": "Мои шаблоны",
        "共享记录": "История обмена",
        "name": "Название",
        "pubdate": "Время публикации",
        "keySeachTip": "Пожалуйста, введите ключевые слова",
        "allGroup": "Все группы",
        "add": "Добавить",
        "edit": "Редактировать",
        "programName": "Название программы",
        "selectGroup": "Выбрать группу"
    },
    "checkManage": {
        "total": "Всего",
        "totalNum": "шт.",
        "operationSuccess": "Операция выполнена успешно",
        "checkUserLogs": "Журналы проверки (операторы)",
        "checkLogs": "Журналы проверки (проверяющие)",
        "sourceCheck": "Проверка материалов",
        "programCheck": "Проверка программ",
        "checkAll": "Выбрать все",
        "auditPass": "Проверка пройдена",
        "auditRefuse": "Проверка отклонена",
        "auditPass01": "Утвердить",
        "auditRefuse01": "Отклонить",
        "auditRefuse02": "Отказать в проверке",
        "auditor": "Проверяющий",
        "agentUserName": "Опубликовавший",
        "interrogationTime": "Время отправки на проверку",
        "checkTime": "Время проверки",
        "checkName": "Название объекта проверки",
        "checkType": "Категория проверки",
        "checkIp": "IP-адрес отправки на проверку",
        "checkReason": "Комментарий",
        "checkStatus": "Содержание операции",
        "rangePicker": "Даты проверки",
        "keyWord": "Ключевые слова",
        "all": "Все",
        "program": "Программа",
        "material": "Материал",
        "dan": "Один",
        "shaung": "Два",
        "pleaseSelectProgram": "Пожалуйста, выберите программу!",
        "pleaseSelectMaterial": "Пожалуйста, выберите материал!",
        "preview": "Предпросмотр",
        "dpi": "Разрешение",
        "auditRefuseTip": "Пожалуйста, введите причину отказа",
        "unreviewed": "Не проверено",
        "notPassed": "Не утверждено",
        "notUsed": "Не используется",
        "edit": "Редактировать",
        "none": "Отсутствует",
        "name": "Название",
        "size": "Размер",
        "type": "Тип",
        "uploadTime": "Время загрузки",
        "uploadUser": "Загрузил",
        "checkUser": "Проверил",
        "image": "Изображение",
        "music": "Музыка",
        "video": "Видео"
    },
    "systemSet": {
        "total": "Всего",
        "totalNum": "шт.",
        "inputPlaceholder": "Пожалуйста, введите",
        "selectPlaceholder": "Пожалуйста, выберите",
        "userList": "Участники организации",
        "roleList": "Роли и права доступа",
        "department": "Структура организации",
        "diskInfo": "Пространство хранения",
        "approveSet": "Утверждение контента",
        "logList": "Управление журналами",
        "name": "Имя",
        "account": "Аккаунт",
        "userName": "Имя пользователя",
        "phoneNumber": "Номер телефона",
        "role": "Роль",
        "createTime": "Время создания",
        "operation": "Действия",
        "edit": "Редактировать",
        "delete": "Удалить",
        "addNew": "Добавить",
        "add": "Добавить",
        "resetPassword": "Сбросить пароль",
        "confirmDelete": "Подтвердить удаление",
        "departmentOrganization": "Структура отделов",
        "addNewUser": "Добавить пользователя",
        "pleaseEnterUserName": "Пожалуйста, введите имя пользователя",
        "confirmPasswordNotMatch": "Подтверждение пароля не совпадает с введенным паролем!",
        "operationSuccess": "Операция выполнена успешно!",
        "userNickname": "Имя пользователя",
        "pleaseEnterUserNickname": "Пожалуйста, введите имя пользователя",
        "userNicknameRequired": "Имя пользователя не может быть пустым!",
        "password": "Пароль",
        "pleaseEnterPassword": "Пожалуйста, введите пароль",
        "passwordRequired": "Пароль не может быть пустым!",
        "passwordTip": "Безопасность вашего пароля слишком низкая (пароль должен содержать любые 3 из следующих типов символов: заглавные буквы, строчные буквы, цифры, специальные символы, и иметь длину от 8",
        "confirmPassword": "Подтвердить пароль",
        "pleaseEnterPhoneNumber": "Пожалуйста, введите номер телефона",
        "phoneNumberRequired": "Номер телефона не может быть пустым!",
        "phoneNumberFormatError": "Пожалуйста, введите корректный номер телефона!",
        "roleRequired": "Роль не может быть пустой!",
        "required": "Не может быть пустым!",
        "departmentName": "Отдел",
        "modifyPassword": "Сменить пароль",
        "newPassword": "Новый пароль",
        "pleaseEnterNewPassword": "Пожалуйста, введите новый пароль",
        "pwdMessage": "Пароль должен содержать от 8 до 20 символов, без пробелов, и включать 3 из следующих типов: заглавные буквы, строчные буквы, цифры, специальные символы",
        "all": "Все",
        "noAuths": "Нет прав доступа, обратитесь к администратору",
        "departmentName01": "Название отдела",
        "image": "Изображение",
        "music": "Музыка",
        "video": "Видео",
        "buySize": "Количество покупки",
        "totalMoney": "Сумма платежа",
        "buycreateTime": "Время покупки",
        "endTime": "Время окончания действия",
        "buyTypeStr": "Тип заказа",
        "sourceCheck": "Проверка материалов",
        "programCheck": "Проверка программ",
        "programName": "Название программы",
        "diskExpansion": "Рекомендуется своевременно очищать устаревшие/неиспользуемые материалы для обеспечения достаточного доступного пространства в системе. Если вам нужно больше места, вы можете обратиться к поставщику оборудования для получения услуги расширения объема облачного хранилища. Эта услуга может быть платной, подробности уточняйте у дистрибьютора.",
        "selectPermission": "Пожалуйста, выберите права доступа",
        "checkPermission": "Пожалуйста, отметьте права доступа",
        "addRole": "Добавить роль",
        "enterRoleName": "Пожалуйста, введите название роли",
        "roleName": "Название роли",
        "roleNameRequired": "Название роли не может быть пустым!",
        "remark": "Примечание",
        "enterRemark": "Пожалуйста, введите примечание",
        "permissionSetting": "Настройка прав доступа",
        "deleteSuccess": "Удалено успешно!",
        "confirmToDelete": "Подтвердить удаление?",
        "orgName": "Название организации",
        "orgNameRequired": "Название организации не может быть пустым!",
        "orgRemark": "Примечание к организации",
        "enterOrgRemark": "Пожалуйста, введите примечание к организации",
        "capacityUsage": "Использование пространства",
        "usedCapacity": "Использованное пространство",
        "totalCapacity": "Общий объем",
        "remainingCapacity": "Оставшееся пространство",
        "capacityExpansion": "Расширение объема",
        "enable": "Включить",
        "disable": "Отключить",
        "userName01": "Имя пользователя",
        "loginTime": "Время входа",
        "ipAddress": "IP-адрес",
        "loginResult": "Результат входа",
        "selectDate": "Выбрать дату",
        "enterDate": "Пожалуйста, выберите дату",
        "selectStartTime": "Пожалуйста, выберите время начала",
        "selectEndTime": "Пожалуйста, выберите время окончания",
        "enterUserName": "Пожалуйста, введите имя пользователя",
        "userCount": "Количество пользователей",
        "roleDesc": "Описание роли",
        "roleAuthorization": "Авторизация роли",
        "success": "Успешно",
        "failure": "Не удалось",
        "time": "Время",
        "operationContent": "Содержание операции",
        "playCount": "Количество воспроизведений",
        "playDuration": "Длительность воспроизведения",
        "selectDevice": "Выбрать устройство",
        "enterProgramName": "Пожалуйста, введите название программы",
        "serialNumber": "Порядковый номер",
        "publishContentName": "Название опубликованного контента",
        "playMode": "Режим воспроизведения",
        "cyclePlay": "Циклическое воспроизведение",
        "insertPlay": "Вставное воспроизведение",
        "paddingPlay": "Заполнительное воспроизведение",
        "playDeviceId": "ID устройства воспроизведения",
        "playDeviceName": "Название устройства воспроизведения",
        "publishTime": "Время публикации",
        "downloadStatus": "Статус загрузки",
        "notDownloaded": "Не загружено",
        "downloading": "Загрузка",
        "downloadSucceeded": "Загрузка успешна",
        "downloadFailed": "Загрузка не удалась",
        "enterPublishContentName": "Пожалуйста, введите название опубликованного контента",
        "terminalId": "ID терминала",
        "belongOrg": "Принадлежащая организация",
        "reportTime": "Время отправки отчета",
        "reportIp": "IP-адрес отправки отчета",
        "logInfo": "Информация из журнала",
        "details": "Детали",
        "confirmDeletion": "Подтвердить удаление?",
        "logDetails": "Детали журнала",
        "download": "Скачать",
        "deptOrg": "Структура отделов",
        "query": "Запрос",
        "queryByTerminalId": "Запрос по ID терминала",
        "batchDeleteLogs": "Групповое удаление журналов",
        "customTimeDeleteLogs": "Удаление журналов за пользовательский период",
        "selectTimeRangeFirst": "Пожалуйста, сначала выберите временной диапазон",
        "deleteAllDeviceLogsIfEmpty": "Если не указать ID устройства, по умолчанию будут удалены журналы всех устройств",
        "enterDeviceIdToDeleteLogs": "Пожалуйста, введите ID устройства, журналы которого нужно удалить",
        "confirmDeleteAction": "Подтвердить удаление",
        "selectDeleteRangeFirst": "Пожалуйста, сначала выберите диапазон удаления",
        "networkConnectionFailed": "Не удалось подключиться к сети",
        "playLog": "Журнал воспроизведений",
        "publishLog": "Журнал публикаций",
        "errorLog": "Журнал ошибок",
        "operationLog": "Журнал операций",
        "fileLog": "Журнал файлов",
        "userOperateLog": "Журнал входов"
    },
    "userManual": {
        "userManual": "Руководство пользователя",
        "noData": "Данные отсутствуют"
    },
    "systemNotice": {
        "systemNotice": "Системные уведомления",
        "noData": "Данные отсутствуют",
        "total": "Всего",
        "totalNum": "шт.",
        "markAllRead": "Отметить все как прочитанные",
        "deleteAll": "Удалить все",
        "all": "Все",
        "unread": "Непрочитанные",
        "read": "Прочитанные",
        "type": "Тип",
        "content": "Содержание",
        "date": "Дата",
        "status": "Статус",
        "confirmDelete": "Подтвердить удаление?",
        "confirm": "Подтвердить",
        "cancel": "Отменить",
        "delete": "Удалить"
    }
};